import {
  availableUsageSpaceOptionsForBuy,
  initialUsageSpaceRange,
} from './usage-space.state';
import { immerOn } from 'ngrx-immer/store';
import {
  resetUsageSpaceFilter,
  setUsageSpaceFilter,
  setUsageSpaceFilterBasedOnUrlValues,
} from './usage-space.actions';
import { resetAllFilters } from '../filter.actions';
import {
  FilterState,
  UsageSpaceFilterState,
  UsageSpaceRange,
} from '@immosky/types';

export const initialUsageSpaceState: UsageSpaceFilterState = {
  isActive: false,
  isDisplayed: false,
  options: [],
  filter: initialUsageSpaceRange,
  default: initialUsageSpaceRange,
};

export const usageSpaceReducers = [
  immerOn(setUsageSpaceFilter, (state: FilterState, { filter }) => {
    updateUsageSpaceFilter(state, filter);
  }),
  immerOn(resetUsageSpaceFilter, resetAllFilters, (state: FilterState) => {
    updateUsageSpaceFilter(state, state.usageSpace.default);
  }),
  immerOn(
    setUsageSpaceFilterBasedOnUrlValues,
    (state: FilterState, { values }) => {
      const minOption = availableUsageSpaceOptionsForBuy.find(
        (o) => o.value === values.min
      );
      const maxOption = availableUsageSpaceOptionsForBuy.find(
        (o) => o.value === values.max
      );

      if (minOption) {
        state.usageSpace.filter.min = minOption;
      }

      if (maxOption) {
        state.usageSpace.filter.max = maxOption;
      }

      state.usageSpace.isActive = isUsageSpaceFilterActive(
        state.usageSpace.filter,
        state.usageSpace.default
      );
    }
  ),
];

export function updateUsageSpaceFilter(
  state: FilterState,
  filter: UsageSpaceRange
) {
  state.usageSpace.filter = filter;
  state.usageSpace.isActive = isUsageSpaceFilterActive(
    state.usageSpace.filter,
    state.usageSpace.default
  );
}

export function isUsageSpaceFilterActive(
  filter: UsageSpaceRange,
  defaultFilter: UsageSpaceRange
): boolean {
  const isMinUsageSpaceDefault = filter.min.value === defaultFilter.min.value;
  const isMaxUsageSpaceDefault = filter.max.value === defaultFilter.max.value;
  return !(isMinUsageSpaceDefault && isMaxUsageSpaceDefault);
}
